import { sendObject } from './handler';

export type GameStopped = { type: 'gameStopped'; game: string; data: any };

export const postSaveGame = async (name: string, data: any): Promise<void> =>
  sendObject({ type: 'gameStopped', game: name, data });
